import React from "react";
const KeyPool = (props) => {
  return <div style={{ margin: "20px" }}>
    <h3 style={{color:"white"}}>This page has no content</h3>
  </div>;
};
const KeyPools = KeyPool;
export default KeyPools;
